/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import type { RequestConfig, ResponseErrorConfig } from '../.kubb/client'
import type {
  GetLedgerModuleByAssetOptions,
  GetLedgerModuleByAssetStatus200,
  GetLedgerModuleByAssetStatus400,
  GetLedgerModuleByAssetStatus404,
  GetLedgerModuleByAssetStatus500,
} from '../types/GetLedgerModuleByAsset'
import type {
  QueryKey,
  QueryClient,
  QueryObserverOptions,
  UseQueryResult,
} from '@tanstack/react-query'
import { getLedgerModuleByAsset } from '../clients/getLedgerModuleByAsset'
import { queryOptions, useQuery } from '@tanstack/react-query'

export const getLedgerModuleByAssetQueryKey = ({
  path,
}: Omit<GetLedgerModuleByAssetOptions, 'headers'>) =>
  [{ url: '/v1/ledger/module/:asset_id', params: path }] as const

type GetLedgerModuleByAssetQueryKey = ReturnType<typeof getLedgerModuleByAssetQueryKey>

export function getLedgerModuleByAssetQueryOptions(
  { path }: GetLedgerModuleByAssetOptions,
  config: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>> = {},
) {
  const queryKey = getLedgerModuleByAssetQueryKey({ path })
  return queryOptions<
    GetLedgerModuleByAssetStatus200,
    ResponseErrorConfig<
      | GetLedgerModuleByAssetStatus400
      | GetLedgerModuleByAssetStatus404
      | GetLedgerModuleByAssetStatus500
    >,
    GetLedgerModuleByAssetStatus200,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      return getLedgerModuleByAsset({
        ...config,
        path,
        signal: config.signal ?? signal,
        throwOnError: true,
      }).unwrap()
    },
  })
}

/**
 * @summary Get the module object for a single asset ID
 * {@link /v1/ledger/module/:asset_id}
 */
export function useGetLedgerModuleByAsset<
  TData = GetLedgerModuleByAssetStatus200,
  TQueryData = GetLedgerModuleByAssetStatus200,
  TQueryKey extends QueryKey = GetLedgerModuleByAssetQueryKey,
>(
  {
    path,
  }: {
    path: GetLedgerModuleByAssetOptions['path'] | (() => GetLedgerModuleByAssetOptions['path'])
  },
  options: {
    query?: Partial<
      QueryObserverOptions<
        GetLedgerModuleByAssetStatus200,
        ResponseErrorConfig<
          | GetLedgerModuleByAssetStatus400
          | GetLedgerModuleByAssetStatus404
          | GetLedgerModuleByAssetStatus500
        >,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient }
    client?: Partial<Omit<RequestConfig, 'path' | 'query' | 'body' | 'headers' | 'url'>>
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {}
  const { client: queryClient, ...resolvedOptions } = queryConfig
  const resolvedParams = { path: typeof path === 'function' ? path() : path }
  const queryKey = resolvedOptions?.queryKey ?? getLedgerModuleByAssetQueryKey(resolvedParams)

  const queryResult = useQuery(
    {
      ...getLedgerModuleByAssetQueryOptions(resolvedParams, config),
      ...resolvedOptions,
      queryKey,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<
    TData,
    ResponseErrorConfig<
      | GetLedgerModuleByAssetStatus400
      | GetLedgerModuleByAssetStatus404
      | GetLedgerModuleByAssetStatus500
    >
  > & { queryKey: TQueryKey }

  queryResult.queryKey = queryKey as TQueryKey

  return queryResult
}
